<ol class="breadcrumb">
    <li class="breadcrumb-item"><a routerLink="/" translate="STATE_root"></a></li>
    @for (link of getStates(); track link.title) {
    <li class="breadcrumb-item">
        <a [routerLink]="link.url" [queryParams]="link.queryParams">
            {{link.title}}
        </a>
    </li>
    }
</ol>